import React, { useRef, useEffect } from 'react';

// Define the props our component needs to mimic a real input
interface DivInputProps {
  value: string;
  // We'll return the text directly, which is simpler than a full event object
  onChange: (text: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  className?: string; // To pass in styles
}

export const DivInput: React.FC<DivInputProps> = ({ value, onChange, onKeyDown, className }) => {
  const ref = useRef<HTMLDivElement>(null);

  // This effect syncs the component's display with the state from the parent,
  // but cleverly avoids moving the user's cursor while they are typing.
  useEffect(() => {
    if (ref.current && ref.current.innerText !== value) {
      ref.current.innerText = value;
    }
  }, [value]);

  // When the user types in the div, this fires.
  const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
    // We call the parent's onChange function with the new text content.
    onChange(e.currentTarget.innerText);
  };

  return (
    <div
      ref={ref}
      className={className}
      contentEditable={true} // This is the magic attribute that makes it editable
      onInput={handleInput}
      onKeyDown={onKeyDown}
      // We don't need a placeholder here because the Ghost div will handle it
    />
  );
};